import { useSprintCrud } from './useSprintCrud';
import { useSprintTrash } from './useSprintTrash';
import { useSprintIcon } from './useSprintIcon';

/**
 * useSprintActions Hook
 * 
 * Orchestrates all sprint operations by combining:
 * - useSprintCrud: Basic CRUD (add, update, rename, create)
 * - useSprintTrash: Trash operations (delete, restore, permanent delete, empty)
 * - useSprintIcon: Icon changes with inherit color resolution
 */
export function useSprintActions({
  sprints,
  setSprints,
  selectedSprintId,
  setSelectedSprintId,
  selectedTemplateId,
  setSelectedTemplateId,
  setCurrentView,
  saveSprint,
  saveSprintImmediate,
  VIEWS,
}) {
  // Basic CRUD operations
  const {
    handleAddSprint,
    handleUpdateSprint,
    handleRenameSprint,
    handleSprintCreated,
  } = useSprintCrud({
    sprints,
    setSprints,
    saveSprint,
    saveSprintImmediate,
  });

  // Trash operations
  const {
    handleDeleteSprint,
    handleRestoreSprint,
    handlePermanentlyDeleteSprint,
    handleEmptyTrash,
  } = useSprintTrash({
    sprints,
    setSprints,
    selectedSprintId,
    setSelectedSprintId,
    selectedTemplateId,
    setSelectedTemplateId,
    setCurrentView,
    VIEWS,
  });

  // Icon operations
  const {
    handleSprintIconChange,
  } = useSprintIcon({
    sprints,
    setSprints,
  });

  return {
    handleAddSprint,
    handleUpdateSprint,
    handleRenameSprint,
    handleDeleteSprint,
    handleRestoreSprint,
    handlePermanentlyDeleteSprint,
    handleEmptyTrash,
    handleSprintCreated,
    handleSprintIconChange,
  };
}

export default useSprintActions;
